import { useState, FormEvent } from "react";
import { Link } from "react-router-dom";

const FORM_URL = "https://readdy.ai/api/form/d6tf897crcujsk0v1900";

export default function PlayitasContact() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("sending");
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((val, key) => data.append(key, val as string));
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) { setStatus("success"); form.reset(); setCharCount(0); }
      else setStatus("error");
    } catch { setStatus("error"); }
  };

  return (
    <>
      <section id="contact" className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
                Gotowy zorganizować swój następny obóz treningowy?
              </h2>
              <div className="space-y-4 mb-12">
                {["Odpowiedź w ciągu 24 godzin", "Spersonalizowana propozycja bez zobowiązań", "Doradztwo doświadczonego zespołu", "Specjalne warunki dla współpracowników"].map(item => (
                  <div key={item} className="flex items-start gap-3">
                    <i className="ri-check-line text-2xl text-orange-500 mt-1" />
                    <span className="text-lg text-gray-700">{item}</span>
                  </div>
                ))}
              </div>
              <div className="space-y-6">
                {[
                  { icon: "ri-mail-line", label: "Email", value: "info@hiszpaniadeluxe.com", href: "mailto:info@hiszpaniadeluxe.com", bg: "bg-orange-100", color: "text-orange-500" },
                  { icon: "ri-phone-line", label: "Telefon", value: "+48 728 958 974", href: "tel:+48728958974", bg: "bg-orange-100", color: "text-orange-500" },
                  { icon: "ri-whatsapp-line", label: "WhatsApp", value: "+48 728 958 974", href: "https://wa.me/48728958974", bg: "bg-green-100", color: "text-green-600" },
                ].map(item => (
                  <a key={item.label} href={item.href} className="flex items-center gap-4 group">
                    <div className={`w-12 h-12 flex items-center justify-center ${item.bg} rounded-full`}>
                      <i className={`${item.icon} text-xl ${item.color}`} />
                    </div>
                    <div>
                      <div className="text-sm text-gray-500">{item.label}</div>
                      <div className="font-semibold text-gray-900 group-hover:text-orange-500 transition-colors">{item.value}</div>
                    </div>
                  </a>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-3xl shadow-xl p-12">
              {status === "success" ? (
                <div className="text-center py-16">
                  <div className="w-16 h-16 rounded-full bg-orange-500 flex items-center justify-center mx-auto mb-5">
                    <i className="ri-check-line text-3xl text-white" />
                  </div>
                  <h3 className="text-2xl font-bold mb-2">Dziękujemy!</h3>
                  <p className="text-gray-600">Skontaktujemy się z Tobą w ciągu 24 godzin.</p>
                  <button onClick={() => setStatus("idle")} className="mt-6 text-sm text-orange-500 underline cursor-pointer">Wyślij kolejną wiadomość</button>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-readdy-form className="space-y-5">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Imię i nazwisko *</label>
                      <input type="text" name="imie_nazwisko" required placeholder="Jan Kowalski"
                        className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                      <input type="email" name="email" required placeholder="jan@example.com"
                        className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Telefon *</label>
                    <input type="tel" name="telefon" required placeholder="+48 123 456 789"
                      className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Specjalizacja *</label>
                    <select name="specjalizacja" required
                      className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm">
                      <option value="">Wybierz specjalizację</option>
                      <option value="crossfit">CrossFit</option>
                      <option value="hyrox">Hyrox</option>
                      <option value="fitness">Fitness</option>
                      <option value="running">Bieganie</option>
                      <option value="triathlon">Triathlon</option>
                      <option value="other">Inne</option>
                    </select>
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Przybliżone daty obozu</label>
                      <input type="text" name="daty" placeholder="np. Czerwiec 2026"
                        className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Liczba uczestników</label>
                      <input type="number" name="uczestnicy" placeholder="20"
                        className="w-full h-14 px-4 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors text-sm" />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Dodatkowa wiadomość</label>
                    <textarea name="wiadomosc" maxLength={500} rows={4} onChange={(e) => setCharCount(e.target.value.length)}
                      placeholder="Powiedz nam więcej o swoim obozie treningowym..."
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-orange-500 focus:outline-none transition-colors resize-none text-sm" />
                    <p className="text-sm text-gray-500 mt-1 text-right">{charCount}/500</p>
                  </div>
                  {status === "error" && <p className="text-red-500 text-sm">Wystąpił błąd. Spróbuj ponownie.</p>}
                  <button type="submit" disabled={status === "sending"}
                    className="w-full h-16 bg-orange-500 hover:bg-orange-600 disabled:bg-gray-400 text-white font-bold text-lg rounded-xl transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-3">
                    WYŚLIJ ZAPYTANIE <i className="ri-send-plane-fill" />
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-gray-900 rounded-t-3xl mx-6 mb-6 px-16 py-20">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-5xl font-black text-white mb-4">Zacznij dziś</h3>
            <p className="text-gray-400 text-xl">Twój następny obóz treningowy na poziomie elity</p>
          </div>
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Linki</h4>
            <ul className="space-y-4">
              {["#facilities", "#accommodation", "#b2b", "#benefits", "#contact"].map((href, i) => (
                <li key={href}>
                  <button onClick={() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" })}
                    className="text-gray-400 hover:text-orange-500 transition-colors cursor-pointer">
                    {["Obiekty", "Zakwaterowanie", "Dla agencji", "Korzyści", "Kontakt"][i]}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Śledź nas</h4>
            <ul className="space-y-4">
              <li><a href="https://www.instagram.com/playitasresort/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-3"><i className="ri-instagram-line" /> Instagram</a></li>
              <li><a href="https://www.facebook.com/PlayitasResort/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-3"><i className="ri-facebook-line" /> Facebook</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white text-lg font-semibold mb-6">Portal Meet Hiszpania</h4>
            <p className="text-gray-400 text-sm mb-4">Playitas Resort jest częścią portalu Meet Hiszpania — platformy B2B dla polskiej branży turystycznej.</p>
            <Link to="/" className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-400 font-semibold transition-colors">
              <i className="ri-arrow-left-line" /> Wróć do portalu
            </Link>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">© {new Date().getFullYear()} Playitas Resort / Meet Hiszpania. Wszelkie prawa zastrzeżone.</p>
          <img src="https://static.readdy.ai/image/2f500271175ac97b037b5e94d69334e6/d3f566fff327433480db44ef3a925506.png"
            alt="Meet Hiszpania" className="h-8 w-auto opacity-60" />
        </div>
      </footer>
    </>
  );
}
